import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'dateFormat',
  standalone: true
})
export class DateFormatPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: Date | string | null | undefined): string {
    if (!value) return 'NA'; // Return 'NA' if the value is null or undefined

    const date = new Date(value);

    if (this.getCurrentLanguage() === 'ar') {
      // Arabic formatting
      const day = date.toLocaleDateString('ar', { day: '2-digit' });
      const month = date.toLocaleDateString('ar', { month: 'long' });
      const year = date.toLocaleDateString('ar', { year: 'numeric' });
      return `${day} ${month} ${year}`;
    } else {
      // English formatting
      const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
      const month = date.toLocaleDateString('en-GB', { month: 'short' });
      const year = date.toLocaleDateString('en-GB', { year: 'numeric' });
      return `${day} ${month}, ${year}`;
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }
}
